import { useEffect, useState } from 'react';

import { Session, redeemLink, storeAccountId } from '../auth';

// Where a magic link lands: /#/auth/link?t={token}. The token is redeemed
// against the API on a fresh Cognito session; the account id comes from the
// verified token's own claims — an emailed link never asks for it again.
export function RedeemLink({ onSignedIn }: { onSignedIn: (s: Session) => void }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const query = window.location.hash.split('?')[1] ?? '';
    const token = new URLSearchParams(query).get('t') ?? '';
    if (!token) {
      setFailed(true);
      return;
    }
    redeemLink(token)
      .then((s) => {
        storeAccountId(s.accountId, false);
        onSignedIn(s);
      })
      .catch(() => setFailed(true));
    // The link is consumed exactly once, on arrival.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="signin-wrap">
      <div className="signin-form-side" style={{ margin: 'auto' }}>
        <div className="signin">
          {failed ? (
            <>
              <h1>That link didn&rsquo;t work</h1>
              <p className="welcome">
                It has expired or was already used — links work for 15 minutes. Ask for a fresh one
                from the sign-in screen.
              </p>
              <a href="#/signin" className="btn lg" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '100%', textDecoration: 'none' }}>
                Back to sign in
              </a>
            </>
          ) : (
            <>
              <h1>Signing you in…</h1>
              <p className="welcome">One moment — checking your link.</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
